import * as React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"
import { Cell, RowContent } from "@tenforce/toolbox-table-react"
import { FieldItems, ReadOnly } from "@tenforce/toolbox-field-react"
import { Labels } from "../../../../util/Translations"

interface Props {
    configuration: Deployment.Configuration
    onExport: (id: string) => void
    onEdit: (id: string) => void
    onRemove: (id: string) => void
}

export default class Row extends React.PureComponent<Props> {
    render(): JSX.Element {
        const { configuration } = this.props
        const { Delete, Edit, Export } = Labels
        return (
            <RowContent
                data-ft-component="export-row"
                data-ft-deployment={`configuration-${configuration.name.toLowerCase()}`}
            >
                <Cell>
                    <FieldItems>
                        <ReadOnly
                            value={configuration.name}
                            title={configuration.name}
                        />
                    </FieldItems>
                </Cell>
                <Cell>
                    <FieldItems>
                        <ReadOnly
                            value={configuration.description}
                            title={configuration.description}
                        />
                    </FieldItems>
                </Cell>
                <Cell>
                    <Action
                        data-ft-deployment="configuration-export"
                        extraClasses="tw-pr-2 tw-pl-6"
                        onClick={this.export}
                    >
                        {Export}
                    </Action>
                    <Action
                        data-ft-deployment="configuration-edit"
                        extraClasses="tw-px-2"
                        onClick={this.edit}
                    >
                        {Edit}
                    </Action>
                    <Action
                        data-ft-deployment="configuration-remove"
                        extraClasses="tw-px-2"
                        onClick={this.remove}
                    >
                        {Delete}
                    </Action>
                </Cell>
            </RowContent>
        )
    }

    export = (): void => {
        const { configuration, onExport } = this.props
        onExport(configuration.id)
    }

    edit = (): void => {
        const { configuration, onEdit } = this.props
        onEdit(configuration.id)
    }

    remove = (): void => {
        const { configuration, onRemove } = this.props
        onRemove(configuration.id)
    }
}
